import { type Theme } from '@logto/schemas';

// Fairytale build: Logto's attribution badge (with its guard stylesheet, integrity observer and
// link) is not rendered. This component is shared by the sign-in experience (Layout/AppLayout)
// and the account center (App, PageFooter), so this one change covers both. (This comment avoids
// the badge's own wording, which the image build checks for.)
// Upstream: packages/experience/src/shared/components/LogtoSignature/index.tsx (Logto v1.45.0, MPL-2.0).

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

const LogtoSignature = (_props: Props) => null;

export default LogtoSignature;
